var _path, _path2, _path3, _g, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascotBio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 55,
    viewBox: "0 0 90 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4994 12.958C79.4988 12.958 79.4988 12.9577 79.4988 12.9573C79.4994 12.9174 79.5 12.8774 79.5 12.8373V5.42172C79.5 1.70623 75.8478 -0.903518 72.3414 0.306591L46.8071 9.11899C45.6691 9.5117 44.4326 9.5123 43.2943 9.12055L17.6541 0.297716C14.1487 -0.908531 10.5 1.70102 10.5 5.41444V12.958V16.7459V42.259C10.5 43.753 9.29118 44.964 7.8 44.964H4.56C2.04158 44.964 0 47.0094 0 49.5326C0 52.0557 2.04158 54.1011 4.56 54.1011H85.44C87.9582 54.1011 90 52.0557 90 49.5326C90 47.0094 87.9582 44.964 85.44 44.964H82.2C80.709 44.964 79.5 43.753 79.5 42.259V12.9587C79.5 12.9583 79.5 12.958 79.4994 12.958Z",
    fill: "#5775FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4988 36.0073H79.4988V42.259C79.4988 43.753 80.7078 44.9641 82.1988 44.9641H7.79883C9.29001 44.9641 10.4988 43.753 10.4988 42.259V36.0073Z",
    fill: "#FFBC57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6116_433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 17,
    width: 18,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.9905C45 22.0106 40.9706 17.9736 36 17.9736C31.0294 17.9736 27 22.0106 27 26.9905V36.0073C27 40.9872 31.0294 45.0242 36 45.0242C40.9706 45.0242 45 40.9872 45 36.0073V26.9905Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6116_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 26.9905C45 22.0106 40.9706 17.9736 36 17.9736C31.0294 17.9736 27 22.0106 27 26.9905V36.0073C27 40.9872 31.0294 45.0242 36 45.0242C40.9706 45.0242 45 40.9872 45 36.0073V26.9905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6983 27.9473C31.5694 28.367 31.5 28.8128 31.5 29.2748V33.7833C31.5 36.2732 33.5147 38.2917 36 38.2917C38.4853 38.2917 40.5 36.2732 40.5 33.7833V29.2748C40.5 26.7849 38.4853 24.7664 36 24.7664C35.5388 24.7664 35.0938 24.8359 34.6749 24.9651C35.4562 25.3185 36 26.106 36 27.0206C36 28.2656 34.9927 29.2748 33.75 29.2748C32.837 29.2748 32.051 28.73 31.6983 27.9473Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6116_433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 17,
    width: 18,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63 26.9905C63 22.0106 58.9706 17.9736 54 17.9736C49.0294 17.9736 45 22.0106 45 26.9905V36.0073C45 40.9872 49.0294 45.0242 54 45.0242C58.9706 45.0242 63 40.9872 63 36.0073V26.9905Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6116_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 26.9905C63 22.0106 58.9706 17.9736 54 17.9736C49.0294 17.9736 45 22.0106 45 26.9905V36.0073C45 40.9872 49.0294 45.0242 54 45.0242C58.9706 45.0242 63 40.9872 63 36.0073V26.9905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6633 28.0067C49.5569 28.3911 49.5 28.7962 49.5 29.2146V33.7548C49.5 36.2448 51.5147 38.2633 54 38.2633C56.4853 38.2633 58.5 36.2448 58.5 33.7548V29.2146C58.5 26.7247 56.4853 24.7062 54 24.7062C53.5688 24.7062 53.1518 24.767 52.757 24.8804C53.4941 25.2506 54 26.0145 54 26.8967V27.1619C54 28.4069 52.9927 29.4162 51.75 29.4162C50.8055 29.4162 49.997 28.8331 49.6633 28.0067Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotBio);
export default __webpack_public_path__ + "static/media/mascot-bio.59939e9fe9ac6444a13811f29e861765.svg";
export { ForwardRef as ReactComponent };